export default __webpack_public_path__ + "static/media/frame.a1dec9e3.png";